/* global jQuery */
(function ($) {

    const gtmEvent = (obj = {}) => {
        const cleanEvent = (str) => {
            return str.replace(/[^a-z0-9_]/gi, '_').toLowerCase()
        }

        //if (window.choicecash.debug)
        //    console.log('GTM: [sent]', obj)

        //let ga4Properties = { ...{
        //        event_name: obj.name || obj.event_name || `event_${obj.event_action || obj.action || ''}`,
        //        event_category: obj.category || '',
        //        event_action: obj.action || '',
        //        event_label: obj.label || ''
        //    }, ...obj };

        var ga4Properties = Object.assign({}, {
            event_name: obj.name || obj.event_name || 'event_' + (obj.event_action || obj.action || ''),
            event_category: obj.category || '',
            event_action: obj.action || '',
            event_label: obj.label || ''
        }, obj);

        delete ga4Properties.name;
        delete ga4Properties.category;
        delete ga4Properties.action;
        delete ga4Properties.label;
        delete ga4Properties.value;

        // Google Analytics 4
        try {
            window.gtag('event', `${ga4Properties.event_category}_${ga4Properties.event_label}`, {})
            window.gtag('event', ga4Properties.event_name, ga4Properties)

            if (`${ga4Properties.event_category}_${ga4Properties.event_label}`.match(/[^a-z0-9_]/gi)) {
                window.gtag('event', cleanEvent(`${ga4Properties.event_category}_${ga4Properties.event_label}`), {})
            }

            if (ga4Properties.event_name.match(/[^a-z0-9_]/gi)) {
                ga4Properties.event_name = cleanEvent(ga4Properties.event_name)
                window.gtag('event', ga4Properties.event_name, ga4Properties)
            }
        } catch (err) {
            console.error('GA4:', err)
        }

    }

    window.lmEvent = gtmEvent;

    /**
     * Events with Google Analytics through Tealium
     *
     * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/sending-hits
     * @link https://community.tealiumiq.com/t5/Tags/Google-Universal-Analytics-Event-Tracking/ta-p/14082
     * @since 06/26/2019
     */
    const gaEvent = (target, action, label) => {
        gtmEvent({
            event: 'ga_event',
            event_category: target,
            event_action: action,
            event_label: label.trim()
        });
    }

    switch (window.location.hostname) {
        case 'www.800loanmart.com':
            gaEvent('track', 'env', 'production');
            break;
        case 'stg.800loanmart.com':
        case 'ec2-18-144-70-218.us-west-1.compute.amazonaws.com':
            gaEvent('track', 'env', 'staging');
            break;
        default:
            gaEvent('track', 'env', 'development');
            break;
    }

    // Track page view via events to set filters on GA for each view type
    gaEvent('track', 'view', window.LM_CFG.gaPageView);

    const $scope = $(document);
    const $navbarScope = $scope.find('.lm-navbar-cta, .lm-navbar-drawer');
    const $triggers = $scope.find('[data-gtm-event]');


    $triggers.on('click', (elm) => {
        let currentElm = $(elm.currentTarget);
        let text = currentElm.text().replace(/\s+/g, ' ').trim();
        let dataObject = {
            event: currentElm.attr('data-gtm-event'),
            event_href: currentElm.attr('href'),
            event_text: text,
            event_pathname: location.pathname
        };
        // if current element has a data-gtm-label attribute
        if (currentElm.attr('data-gtm-label')) {
            dataObject.event_label = currentElm.attr('data-gtm-label');
        }
        // if current have class .lm-btn
        if (currentElm.hasClass('lm-btn') && (text.toLowerCase() === 'apply now' || text.toLowerCase() === 'apply now!' || text.toLowerCase() === 'aplica ahora')) {
            dataObject.event_category = 'Apply Now - Other';
        }

        // if location path starts from /es/ then add es to the label
        if (window.location.pathname.startsWith('/es/')) {
            dataObject.event_category = dataObject.event_category + ' - ES';
        }
        
        gtmEvent(dataObject)
    });


    // people who click on the phone number to call us
    $scope.find('#mainNavPhoneNumber').on('click', () => {
        gaEvent('phone call', 'click', 'phone-call-click');
    });

    // people who click on the phone number to call us
    $scope.find('#lm-navbar a[href^="tel:"]').on('click', () => {
        gaEvent('phone call', 'click', 'phone-call-click');
    });

    // people who click on the apply now button on the top right next to the phone number
    $scope.find('[href*="/apply-title-loans-online/"], [href*="/es/aplica-prestamos-titulo-en-linea/"]').on('click', () => {
        gaEvent('apply now', 'click', 'apply-now-click');
    });

    $scope.find('a[href="https://www2.800loanmart.com/document/"]').on('click', () => {
        gaEvent('click', 'click', 'document-upload');
    });

    $navbarScope.find('[href*="/apply-title-loans-online/"], [href*="/es/aplica-prestamos-titulo-en-linea/"]').on('click', (elm) => {
        let currentElm = $(elm.target);
        gaEvent('apply-now', 'click', currentElm.text());
    });

    // people who click on the Espanol version of the website
    $scope.find('.language_selector .spanish').on('click', () => {
        gaEvent('espanol', 'click', 'espanol-click');
    });

    // people who click on the English version of the website
    $scope.find('.language_selector .english').on('click', () => {
        gaEvent('english', 'click', 'english-click');
    });

    $scope.find('lite-youtube').on('click', () => {
        gaEvent('click', 'click', 'video-click');
    });

})(jQuery);
